import { useAppDispatch, useAppSelector } from '@/hooks/redux';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { Alert, Button, Container, Form } from 'react-bootstrap';
import { Navigate, useNavigate } from 'react-router-dom';
import { contactUser } from '../../store/user/userActions';
 
import { reset, resetUserCreate } from '@/store/user/userSlice';
import * as Yup from 'yup';
import TabNavigation from '../molecules/TabNavigation';

export interface NewUserValues {
  nombre: string;
  telefono: string;
  email: string;
  mensaje: string;
}

const ContactoForm = () => {
  const initialValues: NewUserValues = { 
    nombre:'',
    telefono:'',
    email:'',
    mensaje:'',
   };
  const dispatch = useAppDispatch();
  const { newContactError, newContactLoading, newContactSuccess } = useAppSelector(state => state.user);
  const [addError, setAddError] = useState(false);
  const [addSuccess, setAddSuccess] = useState(false);
  
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required('Este campo es obligatorio')
      .email('Este campo tiene que ser un email')
      .min(0, 'Este campo es obligatorio')
      .matches(/^\s*\S[^]*$/, 'Este campo es obligatorio'),
    nombre: Yup.string()
      .required('Este campo es obligatorio')
      .matches(/^([^0-9]*)$/, 'Ingresa un formato correcto')
      .min(0, 'Este campo es obligatorio')
      .matches(/^\s*\S[^]*$/, 'Este campo es obligatorio'),
    telefono: Yup.string()
      .required('Este campo es obligatorio')
      .min(0, 'Este campo es obligatorio')
      .matches(/^\s*\S[^]*$/, 'Este campo es obligatorio'),
    mensaje: Yup.string()
      .required('Este campo es obligatorio')
      .min(0, 'Este campo es obligatorio')
      .matches(/^\s*\S[^]*$/, 'Este campo es obligatorio'),
  });

  useEffect(() => {
    if (newContactError) {
      setAddError(true);
    }
    if (newContactSuccess) {
      formik.resetForm();
      formik.setValues(initialValues);
      setAddSuccess(true);
    
     }
  }, [newContactError, newContactSuccess]);

  const formik = useFormik({
    initialValues,
    onSubmit: async values => {
      setAddError(false);
      setAddSuccess(false);
      await dispatch(contactUser(values));
    },
    validationSchema: validationSchema,
    validateOnMount: false,
    validateOnChange: false,
    validateOnBlur: false,
  });
 

  return (
    <>
      <Container>
        
     
          <div className="row g-4">
            
                   <Form.Group className="col-md-12">
                            <Form.Control
                              onBlur={formik.handleBlur}
                              isInvalid={formik.errors.nombre ? true : false}
                              required
                              onChange={formik.handleChange}
                              placeholder="Nombre y Apellido"
                              value={formik.values.nombre}
                              name="nombre"
                            />
                            <Form.Control.Feedback type="invalid">{formik.errors.nombre}</Form.Control.Feedback>
                      </Form.Group>

                 
                
                     <Form.Group className="col-md-6">
                            <Form.Control
                              onBlur={formik.handleBlur}
                              isInvalid={formik.errors.telefono ? true : false}
                              required
                              placeholder="Teléfono"
                              value={formik.values.telefono}
                              onChange={formik.handleChange}
                              name="telefono"
                            />
                            <Form.Control.Feedback type="invalid">{formik.errors.telefono}</Form.Control.Feedback>
                      </Form.Group>

                   

                       <Form.Group className="col-md-6">
                         
                            <Form.Control
                              onBlur={formik.handleBlur}
                              isInvalid={formik.errors.email ? true : false}
                              required
                              placeholder="Email"
                              value={formik.values.email}
                              onChange={formik.handleChange}
                              name="email"
                            />
                            <Form.Control.Feedback type="invalid">{formik.errors.email}</Form.Control.Feedback>
                      </Form.Group>
                       <Form.Group className="col-md-12">
                            
                                <Form.Control
                                  onBlur={formik.handleBlur}
                                  isInvalid={formik.errors.mensaje ? true : false}
                                  required
                                  as="textarea"
                                  rows={6}
                                  maxLength={2000}
                                  value={formik.values.mensaje}
                                  placeholder="Mensaje"
                                  onChange={formik.handleChange}
                                  name="mensaje"
                                />
                                <Form.Control.Feedback type="invalid">{formik.errors.mensaje}</Form.Control.Feedback>
                          </Form.Group>
                 
               
                  <div className="col d-grid mb-5">
                        <Button className="btn btn-primary"   onClick={() => formik.handleSubmit()}>
                        Enviar
                        </Button>
                  </div>
        
        </div>
        {addSuccess && (
          <Alert variant="success" dismissible onClose={() => setAddSuccess(false)}>
            <Alert.Heading>¡Muchas Gracias!</Alert.Heading>
            <p>Se envio su consulta correctamente</p>
          </Alert>
        )}
        {addError && (
          <Alert variant="danger" dismissible onClose={() => setAddError(false)}>
            <Alert.Heading>¡Ups, algo salió mal!</Alert.Heading>
            <p>Intenta nuevamente</p>
          </Alert>
        )}

      </Container>
      {newContactLoading && (
        <div>Aguarde un instante...</div>
      )}
    </>
  );
};

export default ContactoForm;
